const article = {
  id: "kalendar-reliza",
  metaTitle: "Календарь релиза: что и за сколько дней успеть | Boostclick",
  metaDescription: "Подготовка релиза по неделям: когда отдавать материал дистрибьютору, когда подавать на питчинг, когда запускать пресейв и что делать в день выхода и после.",
  type: "Гайд",
  category: "Музыка",
  title: "Календарь релиза: что и за сколько дней успеть",
  time: 5,
  data: "31.07.2026",
  imageUrl: "/blogImages/kalendar-reliza/backgroundImage.svg",
  hasDescriptionHeader: true,
  description: `План подготовки релиза с привязкой к датам: четыре недели,
  три недели, две недели, неделя, день выхода и первая неделя после.
  Отдельный раздел — что делать, если релиз выходит послезавтра и половина
  сроков уже прошла.`,
  navigation: [
    { to: "zachem-kalendar", text: "Зачем нужен календарь" },
    { to: "za-4-nedeli", text: "За 4 недели" },
    { to: "za-3-nedeli", text: "За 3 недели" },
    { to: "za-2-nedeli", text: "За 2 недели" },
    { to: "za-nedelyu", text: "За неделю" },
    { to: "den-vyhoda", text: "День выхода" },
    { to: "pervaya-nedelya", text: "Первая неделя после" },
    { to: "esli-vremeni-net", text: "Если времени не осталось" },
    { to: "korotko", text: "Коротко" },
  ],
  section: [
    {
      id: "zachem-kalendar",
      title: "Зачем нужен календарь",
      content: [
        {
          type: "Description",
          text: "Большая часть возможностей релиза закрывается по срокам, а не по бюджету. Питчинг нельзя подать после выхода. Предварительные сохранения нельзя собрать задним числом. Кнопка питчинга появляется не сразу, а через несколько дней после того, как дистрибьютор подтвердил релиз.",
        },
        {
          type: "Description",
          text: "Поэтому релиз удобнее планировать от даты выхода назад. Ниже — рамка по неделям. Сроки, помеченные как официальные, взяты из справки Яндекс Музыки; остальные — запас, который стоит закладывать на практике.",
        },
      ],
    },
    {
      id: "za-4-nedeli",
      title: "За 4 недели: материал и метаданные",
      content: [
        {
          type: "List",
          listType: "ol",
          items: [
            { bold: "Финальный мастер. ", text: "После отправки дистрибьютору поменять файл нельзя без переноса даты." },
            { bold: "Обложка. ", text: "Требования к размеру и содержанию у дистрибьютора свои, проверяются они уже на приёмке — а это потерянные дни." },
            { bold: "Метаданные. ", text: "Имя исполнителя и название трека должны выглядеть ровно так, как вы пишете их везде. Расхождение в одну букву позже сломает и поиск по названию, и статистику." },
            { bold: "Дата выхода. ", text: "Выбирается сейчас, дальше от неё считается всё остальное." },
            { bold: "Верификация артиста в BandLink. ", text: "Если её нет, сделать нужно именно сейчас: без неё не будет ни аналитики, ни страницы пресейва." },
          ],
        },
      ],
    },
    {
      id: "za-3-nedeli",
      title: "За 3 недели: отдать релиз дистрибьютору",
      content: [
        {
          type: "Description",
          parts: [
            "Официальная рекомендация Яндекс Музыки — передать релиз дистрибьютору ",
            { bold: "минимум за две недели" },
            " до даты выхода (",
            { href: "https://yandex.ru/support/music/ru/performers-and-copyright-holders/new-release", text: "справка" },
            "). Три недели — тот же срок с запасом на возврат материала по формальным причинам: не тот размер обложки, спорное название, неверные метаданные.",
          ],
        },
        {
          type: "Description",
          text: "Здесь же стоит заложить время на то, что релиз появляется в кабинете BandLink не мгновенно — обычно на это уходит несколько дней после подтверждения.",
        },
      ],
    },
    {
      id: "za-2-nedeli",
      title: "За 2 недели: питчинг",
      content: [
        {
          type: "Description",
          text: "Кнопка питчинга появляется примерно через 2–4 дня после того, как релиз подтверждён. Подача бесплатная и делается через BandLink.",
        },
        {
          type: "Subtotal",
          title: "Жёсткое ограничение",
          text: "Сингл нужно подать на питчинг до дня выхода — иначе он не сможет участвовать в Нитро, механизме для артистов с аудиторией до 5 000 слушателей в месяц.",
        },
        {
          type: "Description",
          parts: [
            "Что даёт питчинг и как устроены рекомендации, разобрано отдельно: ",
            { to: "/blog/kak-popast-v-moyu-volnu", text: "что влияет на попадание в «Мою волну»" },
            ".",
          ],
        },
      ],
    },
    {
      id: "za-nedelyu",
      title: "За 1,5 недели: пресейв и прогрев",
      content: [
        {
          type: "List",
          listType: "ol",
          items: [
            { bold: "Создать страницу пресейва ", text: "и проверить ссылку с телефона. Нерабочая ссылка обнуляет кампанию целиком." },
            { bold: "Разместить ссылку везде, ", text: "где есть ваша аудитория: закреплённый пост, шапка профиля, описания тизеров, рассылка." },
            { bold: "Запустить кампанию, ", text: "если сохранения добираются заданиями: им нужно время, чтобы разойтись по исполнителям." },
            { bold: "Прогреть интерес: ", text: "тизеры, обложка, отрывки. Чем больше живого внимания вокруг релиза, тем естественнее выглядит вся картина." },
          ],
        },
        {
          type: "Description",
          parts: [
            "Пошаговая инструкция по созданию ссылки — в статье про ",
            { to: "/blog/presave-yandex-music-kak-nastroit", text: "настройку пресейва" },
            "; сами задания на предварительное сохранение — на странице ",
            { to: "/prodvizhenie-trekov-yandexmusic-presave", text: "пресейвы для релиза" },
            ".",
          ],
        },
      ],
    },
    {
      id: "den-vyhoda",
      title: "День выхода",
      content: [
        {
          type: "Description",
          text: "Сохранения срабатывают автоматически: релиз появляется в коллекции слушателя, получает лайк и попадает в его медиатеку. Специально делать в этот день ничего не нужно.",
        },
        {
          type: "Description",
          text: "Полезнее другое: проверить, что релиз действительно доступен, что название и имя исполнителя отображаются правильно, и что трек находится поиском по названию. Ошибка в метаданных, замеченная в первый день, стоит дешевле, чем замеченная через месяц.",
        },
        {
          type: "Footnote",
          textItalic: "Смотреть статистику вечером того же дня смысла нет: аналитика BandLink обновляется раз в сутки после 20:00 по московскому времени.",
        },
      ],
    },
    {
      id: "pervaya-nedelya",
      title: "Первая неделя после выхода",
      content: [
        {
          type: "Description",
          text: "Это период, когда рекомендательная система формирует представление о треке по реакции первых слушателей. Что имеет смысл делать:",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ul",
          items: [
            { text: "поддерживать внимание к релизу теми же каналами, что и до выхода;" },
            { text: "следить за соотношением слушателей и лайков — оно информативнее абсолютных чисел;" },
            { text: "смотреть на суперфанов: в BandLink это те, кто послушал минимум три ваших трека за 28 дней;" },
            { text: "не делать выводов по одному дню — данные приходят с суточной задержкой." },
          ],
        },
        {
          type: "Description",
          parts: [
            "Если нужен объём прослушиваний и действий вокруг трека после выхода, это отдельная услуга: ",
            { to: "/prodvizhenie-trekov-yandexmusic", text: "продвижение треков в Яндекс Музыке" },
            ". Только прослушивания, без дополнительных действий, — ",
            { to: "/prodvizhenie-trekov-yandexmusic-proslushka", text: "здесь" },
            ".",
          ],
        },
      ],
    },
    {
      id: "esli-vremeni-net",
      title: "Если релиз выходит послезавтра",
      content: [
        {
          type: "Description",
          text: "Часть календаря уже не спасти, и честнее это признать, чем пытаться сжать сроки.",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ul",
          items: [
            { bold: "Пресейв-кампанию делать поздно. ", text: "Ссылка может быть ещё не готова, а задания не успеют разойтись." },
            { bold: "Питчинг — проверьте, успеваете ли. ", text: "Для сингла крайний срок — день выхода." },
            { bold: "Планируйте активность после выхода. ", text: "Прослушивания и действия вокруг трека работают и после релиза, в отличие от сохранений." },
            { bold: "Следующий релиз ставьте в календарь заранее. ", text: "Разница между релизом, подготовленным за месяц, и релизом, выпущенным «как получилось», — это в основном разница в сроках, а не в бюджете." },
          ],
        },
      ],
    },
    {
      id: "korotko",
      title: "Коротко",
      content: [
        {
          type: "List",
          listType: "ul",
          items: [
            { text: "4 недели — мастер, обложка, метаданные, дата, верификация." },
            { text: "3 недели — отдать дистрибьютору (официальный минимум — две недели)." },
            { text: "2 недели — питчинг; для сингла крайний срок подачи — день выхода." },
            { text: "1,5 недели — ссылка на пресейв, размещение, запуск кампании, прогрев." },
            { text: "День выхода — проверить доступность и метаданные, статистику не ждать." },
            { text: "Первая неделя — поддерживать внимание и смотреть на соотношения, а не на абсолютные числа." },
          ],
          classes: ["nomargin"],
        },
      ],
    },
  ],
};

export default article;
